import React, { useState } from 'react';
import '../styles/Root.css';
import '../styles/Formulaire.css';

const FormulaireCHETOM = () => {
  const [statusMessage, setStatusMessage] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    setStatusMessage('Envoi en cours...');

    const form = e.target;
    const formData = new FormData(form);

    const data = {
      'first-name': formData.get('first-name'),
      'last-name': formData.get('last-name'),
      'email': formData.get('email'),
      'vous-etes': formData.get('vous-etes'),
      'message': formData.get('message'),
    };

    try {
      const response = await fetch('/api/formulairechetom.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erreur lors de l\'envoi du formulaire');
      }

      const result = await response.json();
      setStatusMessage('Message envoyé avec succès !');
      form.reset();
    } catch (error) {
      setError(error.message);
      setStatusMessage('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <section className="hero fade-in">
        <h1>Formulaire de contact</h1>
        <p>Contactez-nous pour toute question ou demande d'information</p>
      </section>

      <section className="content-section fade-in">
        <h2>Pourquoi nous contacter ?</h2>
        <p>
          Que vous ayez des questions sur nos archives, nos documents, ou que vous souhaitiez simplement vous renseigner sur le CHETOM, n'hésitez pas à nous contacter. Nous sommes là pour vous aider et répondre à toutes vos interrogations.
        </p>
      </section>

      <section className="form-section fade-in">
        <h2>Formulaire de contact CHETOM</h2>
        <form onSubmit={handleSubmit}>
          <label htmlFor="first-name">
            Prénom <span className="required">*</span>
          </label>
          <input type="text" id="first-name" name="first-name" required />

          <label htmlFor="last-name">
            Nom <span className="required">*</span>
          </label>
          <input type="text" id="last-name" name="last-name" required />

          <label htmlFor="email">
            Adresse Email <span className="required">*</span>
          </label>
          <input type="email" id="email" name="email" required />

          <label htmlFor="vous-etes">
            Vous êtes <span className="required">*</span>
          </label>
          <select id="vous-etes" name="vous-etes" required>
            <option value="A">Chercheur - Etudiant</option>
            <option value="B">Enseignant</option>
            <option value="C">Autre</option>
          </select>

          <label htmlFor="message">
            Message <span className="required">*</span>
          </label>
          <textarea id="message" name="message" rows="5" required></textarea>

          {error && <div className="error-message">{error}</div>}
          {statusMessage && <div className="status-message">{statusMessage}</div>}

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Envoi en cours...' : 'Envoyer'}
          </button>
        </form>
      </section>
    </main>
  );
};

export default FormulaireCHETOM;
